import { render, staticRenderFns } from "./realdevices.vue?vue&type=template&id=832bb228&scoped=true"
import script from "./realdevices.vue?vue&type=script&lang=js"
export * from "./realdevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832bb228",
  null
  
)

export default component.exports